import { helper } from '@ember/component/helper';

import ENV from 'rise-ui/config/environment.js';
import { get } from 'rise-ui/utils/object.js';

export default helper(function envHelper([ path ]) {
  return get(ENV, path);
});
